<template>
<center>
    <div class="display-inline" v-on:click="noticeModal($event)">
        <slot name="modal-link"></slot>
    </div>
    <!-- small modal -->
    <modal :show.sync="modals.notice" headerClasses="justify-content-center no-bottom-padding" type="notice">
        <center>
            <h3><i class="tim-icons icon-trash-simple"> Delete Document</i></h3>

            <hr />
            Do you want to delete this document:<br>{{$props.fileName}}
            <div class="container alert_footer">
                <base-button type="danger" @click.native="modals.notice = false" class="mr-4">No
                </base-button>
                <base-button type="primary" @click.native="confirm">Yes
                </base-button>
            </div>
        </center>
    </modal>
</center>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import {
    BaseButton,
    Modal
} from '@/components'

export default {
    name: "UserDocumentsDelete",
    props: {
        id: {
            type: Number,
            default: 0
        },
        fileName: {
            type: String,
            default: ""
        },
        isIcon: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            modals: {
                notice: false,
            }
        };
    },
    components: {
        BaseButton,
        Modal
    },
    methods: {
        noticeModal: function (event) {
            this.modals.notice = true
        },
        confirm(e) {
            this.removeFile().then(response => {
                this.modals.notice = false
                this.$emit("reloadDocuments")
            })
        },
        removeFile() {
            return this.axios.delete(`api/applicationuserfiles/delete/${this.$props.id}`)
        }
    }
}
</script>
